export default __webpack_public_path__ + "static/media/1956.1e3b58c0.png";